import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { HelpViewComponent } from './help-view.component';

@NgModule({
  declarations: [HelpViewComponent],
  exports: [HelpViewComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: HelpViewComponent
      }
    ]),
    SharedModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatProgressSpinnerModule,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      isolate: false
    })
  ]
})
export class HelpViewModule {}
